
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ambassadorOUYDjKiWyyMeta } from "/workspace/pages/ambassador.vue?macro=true";
import { default as callbackEdiDAAfAd4Meta } from "/workspace/pages/auth/callback.vue?macro=true";
import { default as verifiedTiKYllrhf0Meta } from "/workspace/pages/auth/verified.vue?macro=true";
import { default as _91slug_93LM5PuO65NqMeta } from "/workspace/pages/blogs/[slug].vue?macro=true";
import { default as index9KosSeFJvPMeta } from "/workspace/pages/blogs/index.vue?macro=true";
import { default as compareQ8D6isCV5JMeta } from "/workspace/pages/compare.vue?macro=true";
import { default as consults0KdYPVPnhMeta } from "/workspace/pages/consult.vue?macro=true";
import { default as contact_45uszAjl9BMeGEMeta } from "/workspace/pages/contact-us.vue?macro=true";
import { default as exploreoxnV20dS4hMeta } from "/workspace/pages/explore.vue?macro=true";
import { default as free_45consultkyVckxBjIZMeta } from "/workspace/pages/free-consult.vue?macro=true";
import { default as index9S03gOyIVcMeta } from "/workspace/pages/index.vue?macro=true";
import { default as index3tqf0Hxz1SMeta } from "/workspace/pages/invite/index.vue?macro=true";
import { default as referral641Ry3BH56Meta } from "/workspace/pages/invite/referral.vue?macro=true";
import { default as privacypolicyzbhSdV5C3qMeta } from "/workspace/pages/privacypolicy.vue?macro=true";
import { default as applications28CTRqxPMOMeta } from "/workspace/pages/profile/applications.vue?macro=true";
import { default as indexn7j37APTbaMeta } from "/workspace/pages/profile/index.vue?macro=true";
import { default as meetingsh63UgwefLMeta } from "/workspace/pages/profile/meeting.vue?macro=true";
import { default as my_45account6Gb0PFYdldMeta } from "/workspace/pages/profile/my-account.vue?macro=true";
import { default as referral_45bonusIzakoSy6rUMeta } from "/workspace/pages/profile/referral-bonus.vue?macro=true";
import { default as webinarO3qxIwE7jxMeta } from "/workspace/pages/profile/webinar.vue?macro=true";
import { default as _91programSlug_933EKY8WdnjPMeta } from "/workspace/pages/programs/[programSlug].vue?macro=true";
import { default as reset_45passwordQKaug6VSEWMeta } from "/workspace/pages/reset-password.vue?macro=true";
import { default as _91scholarshipSlug_93w9vf1TjmzXMeta } from "/workspace/pages/scholarships/[scholarshipSlug].vue?macro=true";
import { default as indexIDI8gqDSFWMeta } from "/workspace/pages/scholarships/index.vue?macro=true";
import { default as signiniFQrYTNR6TMeta } from "/workspace/pages/signin.vue?macro=true";
import { default as googlektoLiPlLAdMeta } from "/workspace/pages/signup/google.vue?macro=true";
import { default as indexzSnIsKkEd9Meta } from "/workspace/pages/signup/index.vue?macro=true";
import { default as verifyuNE7UIdxGUMeta } from "/workspace/pages/signup/verify.vue?macro=true";
import { default as terms_45conditionsLcpPtJNw9SMeta } from "/workspace/pages/terms-conditions.vue?macro=true";
import { default as _91universitySlug_93fDUtCkgBr8Meta } from "/workspace/pages/universities/[universitySlug].vue?macro=true";
import { default as indexZagEpWR06yMeta } from "/workspace/pages/universities/index.vue?macro=true";
import { default as webinarsEyIgORC50YMeta } from "/workspace/pages/webinars.vue?macro=true";
export default [
  {
    name: "ambassador",
    path: "/ambassador",
    meta: ambassadorOUYDjKiWyyMeta || {},
    component: () => import("/workspace/pages/ambassador.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: callbackEdiDAAfAd4Meta || {},
    component: () => import("/workspace/pages/auth/callback.vue")
  },
  {
    name: "auth-verified",
    path: "/auth/verified",
    meta: verifiedTiKYllrhf0Meta || {},
    component: () => import("/workspace/pages/auth/verified.vue")
  },
  {
    name: "blogs-slug",
    path: "/blogs/:slug()",
    meta: _91slug_93LM5PuO65NqMeta || {},
    component: () => import("/workspace/pages/blogs/[slug].vue")
  },
  {
    name: "blogs",
    path: "/blogs",
    meta: index9KosSeFJvPMeta || {},
    component: () => import("/workspace/pages/blogs/index.vue")
  },
  {
    name: "compare",
    path: "/compare",
    component: () => import("/workspace/pages/compare.vue")
  },
  {
    name: "consult",
    path: "/consult",
    component: () => import("/workspace/pages/consult.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/workspace/pages/contact-us.vue")
  },
  {
    name: "explore",
    path: "/explore",
    meta: exploreoxnV20dS4hMeta || {},
    component: () => import("/workspace/pages/explore.vue")
  },
  {
    name: "free-consult",
    path: "/free-consult",
    meta: free_45consultkyVckxBjIZMeta || {},
    component: () => import("/workspace/pages/free-consult.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index9S03gOyIVcMeta || {},
    component: () => import("/workspace/pages/index.vue")
  },
  {
    name: "invite",
    path: "/invite",
    meta: index3tqf0Hxz1SMeta || {},
    component: () => import("/workspace/pages/invite/index.vue")
  },
  {
    name: "invite-referral",
    path: "/invite/referral",
    meta: referral641Ry3BH56Meta || {},
    component: () => import("/workspace/pages/invite/referral.vue")
  },
  {
    name: "privacypolicy",
    path: "/privacypolicy",
    meta: privacypolicyzbhSdV5C3qMeta || {},
    component: () => import("/workspace/pages/privacypolicy.vue")
  },
  {
    name: "profile-applications",
    path: "/profile/applications",
    meta: applications28CTRqxPMOMeta || {},
    component: () => import("/workspace/pages/profile/applications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexn7j37APTbaMeta || {},
    component: () => import("/workspace/pages/profile/index.vue")
  },
  {
    name: "profile-meeting",
    path: "/profile/meeting",
    meta: meetingsh63UgwefLMeta || {},
    component: () => import("/workspace/pages/profile/meeting.vue")
  },
  {
    name: "profile-my-account",
    path: "/profile/my-account",
    meta: my_45account6Gb0PFYdldMeta || {},
    component: () => import("/workspace/pages/profile/my-account.vue")
  },
  {
    name: "profile-referral-bonus",
    path: "/profile/referral-bonus",
    meta: referral_45bonusIzakoSy6rUMeta || {},
    component: () => import("/workspace/pages/profile/referral-bonus.vue")
  },
  {
    name: "profile-webinar",
    path: "/profile/webinar",
    meta: webinarO3qxIwE7jxMeta || {},
    component: () => import("/workspace/pages/profile/webinar.vue")
  },
  {
    name: "programs-programSlug",
    path: "/programs/:programSlug()",
    meta: _91programSlug_933EKY8WdnjPMeta || {},
    component: () => import("/workspace/pages/programs/[programSlug].vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordQKaug6VSEWMeta || {},
    component: () => import("/workspace/pages/reset-password.vue")
  },
  {
    name: "scholarships-scholarshipSlug",
    path: "/scholarships/:scholarshipSlug()",
    meta: _91scholarshipSlug_93w9vf1TjmzXMeta || {},
    component: () => import("/workspace/pages/scholarships/[scholarshipSlug].vue")
  },
  {
    name: "scholarships",
    path: "/scholarships",
    meta: indexIDI8gqDSFWMeta || {},
    component: () => import("/workspace/pages/scholarships/index.vue")
  },
  {
    name: "signin",
    path: "/signin",
    meta: signiniFQrYTNR6TMeta || {},
    component: () => import("/workspace/pages/signin.vue")
  },
  {
    name: "signup-google",
    path: "/signup/google",
    meta: googlektoLiPlLAdMeta || {},
    component: () => import("/workspace/pages/signup/google.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: indexzSnIsKkEd9Meta || {},
    component: () => import("/workspace/pages/signup/index.vue")
  },
  {
    name: "signup-verify",
    path: "/signup/verify",
    meta: verifyuNE7UIdxGUMeta || {},
    component: () => import("/workspace/pages/signup/verify.vue")
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    meta: terms_45conditionsLcpPtJNw9SMeta || {},
    component: () => import("/workspace/pages/terms-conditions.vue")
  },
  {
    name: "universities-universitySlug",
    path: "/universities/:universitySlug()",
    meta: _91universitySlug_93fDUtCkgBr8Meta || {},
    component: () => import("/workspace/pages/universities/[universitySlug].vue")
  },
  {
    name: "universities",
    path: "/universities",
    meta: indexZagEpWR06yMeta || {},
    component: () => import("/workspace/pages/universities/index.vue")
  },
  {
    name: "webinars",
    path: "/webinars",
    meta: webinarsEyIgORC50YMeta || {},
    component: () => import("/workspace/pages/webinars.vue")
  }
]